import { useDisclosure } from '@chakra-ui/react';
import React from 'react';

import Button from 'ui/Button';
import Tooltip from 'ui/Tooltip';

import NewDiagramFromTemplateModal from '../../components/NewDiagramFromTemplateModal';
import { useOfficeContext } from '../../utils/addin/office';
import { useCurrentUser } from '../../utils/user';

const CreateFromTemplateButton: React.FC = () => {
  const { isExcel } = useOfficeContext();
  const { user } = useCurrentUser();
  const disclosure = useDisclosure();

  const disabledTitle = !user?.can_create_sankeys
    ? !user?.has_active_subscription
      ? 'Please subscribe to create more diagrams'
      : 'Please upgrade your plan or delete some of your existing diagrams to create more diagrams'
    : undefined;

  return (
    <>
      <Tooltip content={disabledTitle} disabled={!disabledTitle}>
        <Button
          variant={isExcel ? 'primary-outline' : 'primary-solid'}
          onClick={disclosure.onOpen}
          disabled={!!disabledTitle}
          w="280px"
        >
          Create from template
        </Button>
      </Tooltip>
      <NewDiagramFromTemplateModal {...disclosure} />
    </>
  );
};

export default CreateFromTemplateButton;
